import React from 'react';

import FilterWrapper from '../../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../../components/Common/InputWrapper';
import FromToDatePicker from '../../../../../components/Common/FromToDatePicker';

class TransactionRestaurantFilter extends React.Component {
  render() {
    const { filters, handleChangeFilters } = this.props;
    const { fromDate, toDate } = filters;
    return (
      <FilterWrapper>
        <InputWrapper>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date => handleChangeFilters('fromDate', date)}
            handleChangeToDate={date => handleChangeFilters('toDate', date)}
          />
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

export default TransactionRestaurantFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/TransactionRestaurant/components/TransactionRestaurantFilter.jsx